import { useState } from 'react';

import axiosPrivate from 'config/axiosPrivate';

export const useAdminRegenerateChatGPTText = ({ textId }) => {
  const [jobStarted, setJobStarted] = useState(null);
  const [startChecking, setStartChecking] = useState(false);

  const regenerateChatGPTText = async () => {
    try {
      const response = await axiosPrivate.post(
        `/texts/${textId}/regenerateChatGPTText`
      );
      setJobStarted(response.data);
      setStartChecking(true);
    } catch (error) {
      console.error('Error generating text:', error);
    }
  };

  return {
    regenerateChatGPTText,
    jobStarted,
    startChecking,
  };
};
